export default __webpack_public_path__ + "static/media/08.8a708328.webp";